<template>
  <div>
    <div
      class="page-content__header-description"
      style="display: flex; margin-bottom: 20px;"
    >
      <h2 style="flex: 1; margin-left: 25px; ">
        Wait-List Customers
      </h2>
    </div>

    <div class="row">
      <div class="col-xl-12 col-lg-12 col-md-12">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :search-options="{
            enabled: true,
            placeholder: 'Search data'
          }"
          :pagination-options="{
            enabled: true,
            perPage: 10
          }"
          :sort-options="{
            enabled: true,
            initialSortBy: { field: 'createdat', type: 'desc' }
          }"
          :line-numbers="true"
          styleClass="vgt-table striped"
          :isLoading.sync="isLoading"
        >
          <div slot="loadingContent">
            Loading data... Please wait
          </div>
          <div slot="emptystate">
            No data found
          </div>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'firstname'">
              {{ props.row.firstname }}
            </span>
            <span v-if="props.column.field == 'lastname'">
              {{ props.row.lastname }}
            </span>
            <span v-if="props.column.field == 'region'">
              {{ props.row.region }}
            </span>
            <span v-else-if="props.column.field == 'phonenumber'">
              {{ props.row.phonenumber }}
            </span>
            <span v-else-if="props.column.field == 'email'">
              {{ props.row.email }}
            </span>
            <span v-else-if="props.column.field == 'createdat'">
              {{ formatDate(props.row.createdat) }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import AnimatedSpinnerLoader from "@/components/AnimatedSpinnerLoader.vue";
import moment from "moment";

export default {
  name: "ListWaitlist",
  components: {
    "animated-spinner": AnimatedSpinnerLoader
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  data() {
    return {
      columns: [
        {
          label: "First Name",
          field: "firstname"
        },
        {
          label: "Last Name",
          field: "lastname"
        },
        {
          label: "Region",
          field: "region"
        },
        {
          label: "Phone Number",
          field: "phonenumber"
        },
        {
          label: "Email",
          field: "email"
        },
        {
          label: "Created At",
          field: "createdat",
          sortable: true,
          type: "date",
  dateInputFormat: "yyyy-MM-dd'T'HH:mm:ss.SSSX",
  dateOutputFormat: "MMM dd, yyyy HH:mm",
  formatFn: this.formatDate
        }
      ],
      isLoading: false,
      rows: []
    };
  },
  computed: {},
  methods: {
    formatDate(value) {
      return moment(value).format('MMM DD, YYYY hh:mm A').replace(/[a-z]/g, (letter) => letter.toUpperCase());
    },
    searchTable(row, col, cellValue, searchTerm) {
      return (
        Object.values(row)
          .join("<%>")
          .toLowerCase()
          .indexOf(searchTerm.toLowerCase()) > -1
      );
    },
    init() {
      const HTTP = this.$httpUtils.FASTHTTP;
      let url = `/waitlist/list`;
        this.isLoading = true;

      HTTP.get(url)
        .then(response => {
          this.rows = response.data.data;
            this.isLoading = false;
        })
        .catch(error => {
            this.isLoading = false;
          this.showErrorMsg({ message: "Error occurred at our end!" });
        });
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style scoped>
.vgt-table.striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}
a:hover {
  color: blue;
  text-decoration: underline;
}

.ellipsis_style {
  font-size: 30px;
  color: #1388bd;
}
.pagin_style {
  color: #85878d;
}
.action_delete {
  color: red;
}
.action_delete:hover {
  background-color: red;
  color: whitesmoke;
}
.action_update {
  color: #1388bd;
}
.action_update:hover {
  background-color: #1388bd;
  color: whitesmoke;
}
.el-input__inner {
  border-radius: 10px;
  /* width: 360px; */
  background-color: #eff0f4;
  border-color: #eff0f4;
}
.triangle {
  /* background-color: red; */
  width: 40%;
  margin-left: auto;
  margin-right: auto;
}
.form {
  width: 55%;
  margin-left: auto;
  margin-right: auto;
}

h4 {
  font-weight: 600;
  color: #6a707e;
  border: none;
  text-align: center;
}

.row {
  margin: 20px 0px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.button-delete {
  padding: 5px;
  color: white;
  border-color: red;
  background: red;
  border-radius: 8px;
  width: 49%;
  margin-right: -7px;
}

.button-delete:hover {
  padding: 5px;
  color: white;
  border-color: rgb(146, 1, 1);
  background: rgb(146, 1, 1);
  border-radius: 8px;
  width: 49%;
  margin-right: -7px;
}

.red-border {
  border: 2px solid red;
  width: 30px;
}

.button-cancel {
  padding: 5px;
  color: grey;
  border: 1px solid grey;
  background: white;
  width: 49%;
  border-radius: 8px;
}

.button-cancel:hover {
  padding: 5px;
  color: white;
  border: 1px solid grey;
  background-color: #85878d;
  width: 49%;
  border-radius: 8px;
}

table th,
table th span {
  font-size: 0.7em;
}
.onboarding-page {
  height: calc(100vh - 250px);
}
.uk-offcanvas-bar {
  width: 90vw !important;
}
.action_style {
  display: flex;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboardingTracker/ListWaitlist.vue